<template>
  <div class="items-list-view mb-base">
    <vx-card class="list-view-item overflow-hidden p-0">
      <template slot="no-body">
        <div
          :id="`parentx-demo-${index}`"
          class="vx-row item-details no-gutter"
          :class="{ 'height-card': sizeSidebar }"
        >
          <vs-sidebar
            click-not-close
            :parent="`#parentx-demo-${index}`"
            :hidden-background="true"
            default-index="1"
            color="primary"
            class="full-vs-sidebar-shop sidebarx"
            position-right
            v-model="active"
            style="padding: 0px !important"
          >
            <Setting :index="index" @active="active = $event" @hasComponent="hasComponent = $event"></Setting>
          </vs-sidebar>

          <div class="vx-col w-full">
            <div class="p-4 pt-6">
              <vs-row>
                <vs-col class="px-0 md:px-2" vs-lg="12" vs-sm="12" vs-xs="12">
                  <!-- ========================================================================================================================================== -->
                  <vs-row vs-type="flex" vs-justify="flex-between">
                    <vs-col vs-type="flex" vs-justify="flex-center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
                      <h5>
                        {{ $t(`INPUTTYPE.${OriginType}.${inputType}`) }}
                      </h5>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
                      <slot name="move_question"></slot>
                    </vs-col>
                    <vs-col
                      class="pt-5 md:pt-0 justify-start md:justify-end"
                      vs-type="flex"
                      vs-align="center"
                      vs-lg="4"
                      vs-sm="12"
                      vs-xs="12"
                    >
                      <vs-chip :color="colorChip" class="product-order-status px-4 mr-2">{{
                        $t(`MODULE.${questionsOrComponents}`)
                      }}</vs-chip>

                      <span class="mr-2">ID </span
                      ><span class="font-bold" :style="{ color: '#7367F0' }">{{ questionsByPage[index].name }}</span>
                    </vs-col>
                  </vs-row>
                  <!-- ========================================================================================================================================== -->
                  <vs-row>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                      <vs-input
                        :label="$t(`MODULE.label`)"
                        :placeholder="$t(`MODULE.placeHolderLabel`)"
                        class="w-full px-0 md:px-2"
                        v-model="questionsByPage[index].label"
                      />
                    </vs-col>
                  </vs-row>

                  <div class="flex items-end flex-col md:flex-row">
                    <vs-row class="mb-4 text-left" vs-justify="center">
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" vs-lg="6">
                        <vs-select
                          autocomplete
                          class="selectExample mt-5 w-full md:full px-0 md:px-2"
                          v-model="type"
                          :label="$t(`MODULE.component`)"
                        >
                          <vs-select-item
                            :key="index"
                            :value="item"
                            :text="$t(`FORMS.${item}`)"
                            v-for="(item, index) in getTypes"
                          />
                        </vs-select>
                      </vs-col>
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" vs-lg="6">
                        <vs-select
                          autocomplete
                          class="selectExample mt-5 w-full px-0 md:px-2"
                          v-model="inputType"
                          :label="$t(`MODULE.class`)"
                        >
                          <vs-select-item
                            :key="index"
                            :value="inputType"
                            :text="$t(`INPUTTYPE.${OriginType}.${inputType}`)"
                            v-for="(inputType, index) in listInputType"
                          />
                        </vs-select>
                      </vs-col>
                    </vs-row>
                    <div
                      v-if="hasComponent || inputType === 'flex'"
                      class="w-full md:w-1/4"
                      style="margin-bottom: 1rem !important"
                    >

                      <vs-button
                        class="w-full md:w-0"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-settings"
                        @click="eventBtnConf()"
                      >
                        {{ $t(`MODULE.setting`) }}
                      </vs-button>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
              <vs-row class="text-left" vs-type="flex" vs-justify="center">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" vs-lg="12">
                  <vs-input
                    class="w-full px-0 md:px-4"
                    :label="$t(`MODULE.description`)"
                    :description-text="$t(`MODULE.subtitleDescription`)"
                    v-model.trim="questionsByPage[index].help"
                  />
                </vs-col>
              </vs-row>
              <vs-alert class="mb-3" color="danger" :active="!validateQuestion.boolean">
                {{ validateQuestion.field }}
              </vs-alert>

              <!-- FOOTER DEPENDENCIAS -->
              <FooterDepedencias :index="index">
                <vs-button
                  class="inline-block lg:inline-block w-full"
                  color="success"
                  type="border"
                  @click="OpenPopup"
                  >{{ $t(`MODULE.btnAddDependency`) }}</vs-button
                >
              </FooterDepedencias>
              <!--END FOOTER DEPENDENCIAS -->

              <!-- FOOTER CARD -->
              <vs-row class="mt-5">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <!-- {{requiredIsFalseDefault}} ---- {{inputType}} -->
                  <div class="flex ml-3" v-if="!requiredIsFalseDefault.includes(inputType)">
                    <label class="mr-3">{{ $t(`MODULE.required`) }}</label>
                    <vs-switch v-model="questionsByPage[index].required" />
                  </div>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                  <feather-icon class="ml-3" icon="HelpCircleIcon" svgClasses="h-7 w-7" />
                  <vx-tooltip text="Mover pregunta" position="top">
                    <feather-icon
                      class="ml-3 cursor-pointer"
                      icon="RepeatIcon"
                      svgClasses="h-7 w-7"
                      @click="MoveQuestion"
                    />
                  </vx-tooltip>

                  <vx-tooltip text="Eliminar pregunta" position="top">
                    <feather-icon
                      class="ml-3 cursor-pointer"
                      icon="Trash2Icon"
                      svgClasses="h-7 w-7"
                      @click="deleteQuestion"
                    />
                  </vx-tooltip>

                  <vx-tooltip text="Duplicar pregunta" position="top">
                    <feather-icon
                      class="ml-3 cursor-pointer"
                      icon="CopyIcon"
                      svgClasses="h-7 w-7"
                      @click="copyQUestion"
                    />
                  </vx-tooltip>

                  <slot name="IconsFooter"></slot>
                </vs-col>
              </vs-row>
              <!--END FOOTER CARD -->
            </div>
          </div>
        </div>
      </template>
    </vx-card>
    <VModalPopup
      ref="5943e964-679b-438b-887a-952635a73349"
      v-if="ActivePopupC"
      :id="`VModalPopup_${index}`"
      :active.sync="ActivePopupC"
      :header="true"
      Clases="py-0 pl-0"
      :title="$t(`MODALS.modalDependencias.dependencyBuilder`)"
    >
      <div class="border border-t-0 border-l-0 border-r-0 px-3 flex justify-between items-center" style="height: 40px">
        <h5>{{ $t(`MODALS.modalDependencias.dependence`) }} {{ tittleHeader }}</h5>
        <div v-if="isStandard">
          <vs-radio class="mr-12" v-model="activeComputed_" vs-value="true">{{
            $t(`MODALS.modalDependencias.standard`)
          }}</vs-radio>
          <vs-radio v-model="activeComputed_" vs-value="false">{{ $t(`MODALS.modalDependencias.composite`) }}</vs-radio>
        </div>
      </div>

      <Standard :active="activeComputed" @changeAcive="activeComputed_ = $event"></Standard>

      <Computed
        :active="isStandard && activeComputed"
        :isStandard="isStandard"
        @changeAcive="activeComputed_ = $event"
        :father="`VModalPopup_${index}`"
      ></Computed>
    </VModalPopup>
  </div>
</template>

<script type="text/javascript">
import { setQuestion, getAllQuestion } from "../indexDB/logic.js";
import { deleteDependenceDad, getListener, deleteListener } from "../indexDB/dependencies.js";
import { mapMutations, mapState, mapActions } from "vuex";
// import settings from '../provider/settingForm.js';
import { clasesQuestions, listComponents } from "../provider/clases-questions.js";
import { ValidateQuestion } from "../provider/validator.js";
import mixin from "./mixin.js";
import Setting from "./Setting.vue";
import { notify } from "@/serviforms/designer/helpers/";
import { _Permissions } from "@/acl/permitions.js";

import VModalPopup from "@/serviforms/designer/components/Modals/compounds/Main.vue";

// import Standard from "./dependencies/standard.vue";
import Standard from "./dependencies/standard.vue";
import Computed from "./dependencies/compound.vue";
import FooterDepedencias from "./dependencies/footerDepedencias.vue";

export default {
  components: { Setting, VModalPopup, Standard, Computed, FooterDepedencias },
  mixins: [mixin, _Permissions],
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  watch: {
    ActivePopupC(value) {
      if (value) this.activeComputed_ = "true";
    }
  },
  data() {
    return {
      activeComputed_: "true",
      ActivePopupC: false,
      hasComponent: true,
      active: false,
      clasesQuestions,
      hasDependencies: [
        "default",
        "email",
        "barcode",
        "phone",
        "textarea",
        "password",
        "ranking",
        "slider",
        "number",
        "currency",
        "ipv4",
        "ipv6",
        "domain",
        "multiInput",
        "checktext",
        "QRReader",
        "multi",
        "multiOther",
        "radio",
        "radioOther",
        "standar",
        "switch",
        "gallery/camera",
        "gallery",
        "camera"
      ],
      feactures: {
        datasource: "data_origin",
        subform: "sub_forms"
      },
      tabActive: ["border", "border-t-0", "border-l-0", "border-r-0", "active", "text-white", "rounded-t-lg", "py-2"],
      tabInactive: [
        "py-2",
        "border",
        "border-t-0",
        "border-l-0",
        "border-r-0",
        "inactive",
        "text-white",
        "rounded-t-lg"
      ]
    };
  },
  computed: {
    ...mapState("resource", ["questionsByPage", "counter", "saveCreatedDependecies", "dataSidebar"]),
    /**
     * Valida si la dependencia seleccionada n el radio buttom es standard o compuesta.
     */
    isStandard() {
      if (this.type === "datasource") return false;
      return this.hasDependencies.includes(this.inputType);
    },
    /**
     * Filtra la lista de componentes ó preguntas segun el tipo de formulario que se esta trabajando (standard, subformulario, bot).
     */
    questions() {
      return listComponents[this.typeForm].questions;
    },
    /**
     * Obitiene la lista de componentes ó preguntas segúb el tipo de formulario.
     */
    components() {
      return listComponents[this.typeForm].components;
    },
    sizeSidebar() {
      if (this.active) return true;
    },
    /**
     * Obtiene el tipo de pregunta
     */
    OriginType() {
      return this.question.type;
    },
    /**
     * Obtiene el tipo de formulario que se esta trabajando.
     */
    typeForm() {
      if (this.dataSidebar.isSubForm === "0" || this.dataSidebar.isSubForm === false) return "standar";
      if (this.dataSidebar.isSubForm === "1") return "suform";
      if (this.dataSidebar.isSubForm === "2") return "bot";
    },
    type: {
      get() {
        return this.GET_TYPE(this.question.inputType);
      },
      set(value) {
        const { name, label, help } = this.question;
        const element = Object.values(clasesQuestions[this.typeForm][value]);
        const funcion = element[0];
        const result = funcion(name, label, help);
        this.changeQuestion(result);
      }
    },
    inputType: {
      get() {
        return this.question.inputType;
      },
      set(value) {
        const { name, label, help } = this.question;
        const funcion = clasesQuestions[this.typeForm][this.type][value];
        const result = funcion(name, label, help);
        this.changeQuestion(result);
      }
    },
    /**
     * Obtiene el valor booleano que indica si la pregunta es requerida ó no.
     */
    required() {
      return this.questionsByPage[this.index].required;
    },
    /**
     * Filtra la lista de preguntas que se puede trabajar en el formulario segun el tipo de formulario y segun el tipo de pregunta.
     */
    listInputType() {
      if (
        this.clasesQuestions[this.typeForm][this.type] === null ||
        this.clasesQuestions[this.typeForm][this.type] === undefined
      )
        return;
      return Object.keys(this.clasesQuestions[this.typeForm][this.type]);
    },
    /**
     * Obtiene la estutura de la pregutna sobre la que se esta realizando algún tipo de acción
     */
    question() {
      return this.questionsByPage[this.index];
    },
    getTypes() {
      if (this.questions.includes(this.question.type)) {
        if (this.question.type === "photo" && this.question.inputType === "url") return this.components;
        return this.questions.filter(component => {
          if (this.feactures[component]) return this.CheckPermision(this.feactures[component]);
          return true;
        });
      }

      return this.components.filter(component => {
        if (this.feactures[component]) return this.CheckPermision(this.feactures[component]);
        return true;
      });
    },
    colorChip() {
      if (this.questionsOrComponents === "Componente") return "#38BDAA";
      if (this.questionsOrComponents === "Pregunta") return "#7367F0";
    },
    /**
     * Verifica si el tipo de pregunta es de tipo pregunta o componente.
     */
    questionsOrComponents() {
      if (this.questions.includes(this.question.type)) {
        if (this.question.type === "photo" && this.question.inputType === "url") return "Componente";
        return "Pregunta";
      }
      return "Componente";
    },
    /**
     * Dependiendo del tipo de pregunta el switch requerido se ocultara para aquellos que la propiedad required sea falsa por defecto.
     */
    requiredIsFalseDefault() {
      // if (this.question.type === "datasource" && this.question.inputType === "standar") return ["standar"];
      if (this.question.type === "map") return ["google", "servi"];
      return ["label", "paragraph", "link", "section", "info", "url", "web", "document", "select"];
    },
    /**
     * Titulompara la cabecera del modal que configura las dependencias.
     */
    tittleHeader() {
      return this.isStandard && this.activeComputed
        ? this.$t(`MODALS.modalDependencias.standard`)
        : this.$t(`MODALS.modalDependencias.composite`);
    },
    validateQuestion() {
      const result = ValidateQuestion(this.question);
      return result;
    },
    activeComputed() {
      return this.activeComputed_ === "true" ? true : false;
    }
  },
  methods: {
    ...mapActions("resource", ["getCreatedDependencies"]),
    ...mapMutations("resource", ["CHANGE_QUESTION", "UPDATE_STATE", "DELETE_QUESTION", "COPY_QUESTION"]),
    GET_TYPE(inputType) {
      switch (inputType) {
        case "number":
        case "currency":
          return "number";
        case "ranking":
        case "slider":
          return "ranges";
        case "ipv6":
        case "ipv4":
        case "domain":
          return "network";
        case "multiInput":
        case "checktext":
          return "list";
        case "QRReader":
        case "QRGen":
          return "qr";
        case "label":
        case "paragraph":
        case "link":
        case "section":
        case "info":
        case "action":
          return "informative";
        case "url":
          if (this.question.type === "photo") return "imagen_url";
          return "video";

        default:
          return this.question.type;
      }
    },
    /**
     * Despliega el modal para cambiar una pregunta de posición ó de página.
     */
    async MoveQuestion() {
      this.UPDATE_STATE({ key: "componentPopup", value: "MoveQuestion" });
      this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
      setTimeout(() => this.UPDATE_STATE({ key: "activePopup", value: true }), 50);
    },
    /**
     * Realiza una mutación de la pregunta a otro tipo ó clase.
     * @param { Object } question - Objeto con la nueva estructura de la pregunta.
     */
    async changeQuestion(question) {
      const nameDad = this.question.name;
      await deleteDependenceDad(nameDad);
      const payload = {
        index: this.index,
        question
      };
      this.CHANGE_QUESTION(payload);
      await this.reorganizarIndex(nameDad);
      await this.getCreatedDependencies();
      setQuestion();
    },
    /**Elimina las dependencias listener del formulario.
     *
     */
    async deleteListener() {
      if (this.questionsByPage[this.index].query) {
        const action = this.questionsByPage[this.index].query.action;
        if (action === "trigger") {
          deleteListener(this.questionsByPage[this.index].name);
          return false;
        } else {
          const { listener } = await getListener();
          let isInListener = false;
          for (const i in listener) {
            if (listener[i].related.name === this.questionsByPage[this.index].name) {
              const text = `Esta pregunta esta vinculada a un database selección de ID ${i} (relación listener)`;
              notify("Mensaje", text, "warning");
              isInListener = true;
              break;
            }
          }
          return isInListener;
        }
      } else return false;
    },
    /**
     * Activa la ventana de configuración de la preguta. En caso de ser flexible abre un popup.
     */
    async eventBtnConf() {
      setQuestion();
      if (this.inputType === "flex") {
        const result = await getAllQuestion();
        this.UPDATE_STATE({ key: "AllQuestions", value: result });
        this.UPDATE_STATE({ key: "componentPopup", value: "FlexSetting" });
        this.UPDATE_STATE({ key: "activePopup", value: true });
        this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
      } else if (this.inputType === "info") {
        this.active = !this.active;
      } else this.active = !this.active;
    },
    /**
     * Despliega el popup para agregar las dependencias.
     */
    OpenPopup() {
      setQuestion();
      this.ActivePopupC = true;
      this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
    },
    totalQuestion(object) {
      if (object) {
        const keys = Object.keys(object);
        return keys.length;
      }
      return 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.height-card {
  min-height: 400px;
}
</style>
